import { getDecimalNumberParts } from '@/lego/utils/math/array';

export function onElementResize(el, cb) {
  const observer = new ResizeObserver(entries => {
    const [entry] = entries;
    const { width, height } = entry.contentRect;
    cb({ width, height });
  });

  observer.observe(el);
}

export function onElementIntersect(el, cb) {
  function callback(entries) {
    const [entry] = entries;
    cb(entry.intersectionRatio);
  }

  const observer = new IntersectionObserver(callback, {
    root: document.body,
    threshold: getDecimalNumberParts(),
  });

  observer.observe(el);
}

export function onEnter(el, cb) {
  el.addEventListener('mouseenter', cb);
}

export function onLeave(el, cb) {
  el.addEventListener('mouseleave', cb);
}

export function getRelativePosition(el) {
  const box = el.getBoundingClientRect();

  const body = document.body;
  const docEl = document.documentElement;

  const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
  const scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

  const clientTop = docEl.clientTop || body.clientTop || 0;
  const clientLeft = docEl.clientLeft || body.clientLeft || 0;

  const top = box.top + scrollTop - clientTop;
  const left = box.left + scrollLeft - clientLeft;

  return { top, left };
}
